import type { Product } from '~/utilities/graphql/codegen';

export const getProductBaseCode = (product: Product): string =>
  (product?.baseProduct || product?.code?.split('-').slice(0, 3).join('-') || '').toUpperCase();
